import { Icon, PageHead } from '../ui';
import { TopBar } from './TopBar';

const NEXT = [
  { icon: 'tasks', title: 'Задачи и передача задач', text: 'Поставить задачу по станку, передать коллеге, принять или вернуть с причиной. Уведомления в боте.' },
  { icon: 'log', title: 'Сменное задание', text: 'План смены по линии от мастера и отметки факта от оператора, простои.' },
  { icon: 'factory', title: 'Склад: адресное хранение', text: 'Ячейки, остатки и движения — остаток всегда сходится с историей.' },
  { icon: 'edit', title: 'Продукт и переналадка', text: 'Карточка продукта и карта перехода «линия × продукт A → B» с параметрами и фото.' },
  { icon: 'info', title: 'База знаний и советы ИИ', text: 'Инструкции и паспорта оборудования; помощник отвечает со ссылкой на источник.' },
];

/** Вкладка «Задачи»: модуль следующего этапа. Пока — что появится и в каком порядке. */
export function Tasks() {
  return (
    <div className="stack">
      <TopBar />
      <PageHead title="Задачи" />
      <div className="card flat">
        <p style={{ margin: 0 }}>Этот раздел в работе. Каркас для него уже есть: роли, участки и дерево производства, к которым будут привязаны задачи.</p>
      </div>
      <h2 className="section-title">Дальше по плану</h2>
      <div className="list">
        {NEXT.map((n, i) => (
          <div key={n.title} className="item" style={{ alignItems: 'flex-start' }}>
            <span className="mark" aria-hidden="true">
              <Icon name={n.icon} />
            </span>
            <span className="grow stack" style={{ gap: 2 }}>
              <span className="title">
                {i + 1}. {n.title}
              </span>
              <span className="sub">{n.text}</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
